import { inject, Injectable } from '@angular/core';
import { forkJoin, from, Observable } from 'rxjs';
import { ApiResponse } from './api-contracts';
import { AwsApiWrapperService, BsCacheService } from '@brightside-web/desktop/data-access/core-services';
import { HttpClient } from '@angular/common/http';
import { concatMap, map } from 'rxjs/operators';
import moment from 'moment';
import { CompanyService } from '@brightside-web/desktop/data-access/shared';

export enum NotificationMessageTypeEnum {
  CHANGE_EMAIL = 'account-change-password-notify',
}

export enum NotificationMessageChannelEnum {
  EMAIL = 'email',
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private _companyService: CompanyService = inject(CompanyService);
  private _awsApiWrapperService: AwsApiWrapperService = inject(AwsApiWrapperService);
  private _bsCacheService: BsCacheService = inject(BsCacheService);

  constructor(private http: HttpClient) {}

  sendMessage(messageType: NotificationMessageTypeEnum, channel: NotificationMessageChannelEnum): void {
    this._awsApiWrapperService.post('api-mobile', '/notification', {
      body: {
        messageType,
        channel,
      },
    });
  }

  generateDynamicLink(route: string, cardName: string): Observable<ApiResponse> {
    return from(
      this._awsApiWrapperService.post('api-mobile', '/notification', {
        body: {
          messageType: 'desktopCardToMobile',
          channel: 'sms',
          dynamicLink: route,
          cardName,
        },
      })
    );
  }
  // TODO: ken check this
  sendGetTheAppMessage(phone_number: string, user_agent: string): Observable<ApiResponse> {
    return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json').pipe(
      concatMap((ip) =>
        from(this._bsCacheService.getItem('referrer')).pipe(
          map((referrer) => {
            if (!referrer) {
              this._bsCacheService.setItem('referrer', this._companyService.getCompany(), {
                expires: moment().add(6000, 'seconds').valueOf(),
              });
              referrer = this._companyService.getCompany();
            }
            return { ipInfo: ip, referrer };
          })
        )
      ),
      concatMap((resp: { ipInfo: { ip: string }; referrer: string }) =>
        from(this._bsCacheService.getItem('referrerType')).pipe(
          map((referrerType) => {
            if (!referrerType) {
              this._bsCacheService.setItem('referrerType', 'desktop', { expires: moment().add(6000, 'seconds').valueOf() });
              referrerType = 'desktop';
            }
            return { ...resp, referrerType };
          })
        )
      ),
      concatMap((final: { ipInfo: { ip: string }; referrer: string; referrerType: string }) =>
        from(
          this._awsApiWrapperService.post('api-mobile-noauth', '/landingpage', {
            body: {
              referrer: final.referrer,
              referrerType: final.referrerType,
              company: 'app',
              phone_number,
              user_agent,
              ip_address: final.ipInfo.ip,
            },
          })
        )
      )
    );
  }
}
